import i18n, { t } from 'i18next'

import { isLanguage, Languages } from '@/enums/languages'

type ContentType<T> = { [key in Languages]?: T }

export const getLocalizedContent = <T>(content: ContentType<T>): T | '' => {
  const currentLocale = isLanguage(i18n.resolvedLanguage) ? i18n.resolvedLanguage : Languages.EN

  const localeContent = content[currentLocale] || content[Languages.EN]

  if (!localeContent) {
    console.warn(`Can't get content for ${currentLocale} locale in ${content}`)
    return ''
  }

  return localeContent
}

export const getTranslation = (key: string) => {
  const translation = t(key)
  return translation !== key ? translation : ''
}

export const getCurrentLanguage = () => {
  return i18n.resolvedLanguage
}
